<template>
    <div>
        <div class="swal2-icon swal2-success swal2-animate-success-icon" style="display: block;">
            <div class="swal2-success-circular-line-left" style="background-color: rgb(255, 255, 255); background-position: initial initial; background-repeat: initial initial;"></div>
            <span class="swal2-success-line-tip swal2-animate-success-line-tip"></span>
            <span class="swal2-success-line-long swal2-animate-success-line-long"></span>
            <div class="swal2-success-ring"></div> <div class="swal2-success-fix" style="background-color: rgb(255, 255, 255); background-position: initial initial; background-repeat: initial initial;"></div>
            <div class="swal2-success-circular-line-right" style="background-color: rgb(255, 255, 255); background-position: initial initial; background-repeat: initial initial;"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: '',
        data() {
            return {}
        },
        created() {
        },
        methods: {}
    }
</script>

<style lang="sass">

</style>


// WEBPACK FOOTER //
// src/components/ui/SuccessIcon.vue